<syn-tooltip [content]="'header.changeTimezone' | translate" placement="bottom">
  <a
    class="flex items-center gap-1.5 px-2 py-1 rounded transition-colors cursor-pointer no-underline"
    style="color: currentColor; outline: none"
    [routerLink]="['/', profileUrl]"
    [queryParams]="{ tab: 'preferences' }"
    [attr.aria-label]="'header.changeTimezone' | translate"
  >
    <syn-icon name="schedule" style="font-size: 1.25rem; color: inherit"></syn-icon>
    <span class="hidden md:inline text-sm font-semibold" style="color: inherit">{{ timezone() }}</span>
    <span class="text-sm" style="color: inherit">{{ offset() }}</span>
  </a>
</syn-tooltip>
